import { Collection } from 'modules/core/lib/mobx-rest'

import SupplementBulkImport from 'modules/payroll_bundle/store/models/SupplementBulkImport'

class SupplementBulkImports extends Collection<SupplementBulkImport> {
  get cacheKey(): string {
    return 'supplementBulkImports'
  }

  model() {
    return SupplementBulkImport
  }
}

const singleton: SupplementBulkImports = new SupplementBulkImports()

export default singleton
